<template>
  <section class="index-footer">
    <!-- <div class="footer-head">
      <div class="tips"></div>
      <div class="lets-talk">
        让我们谈谈
      </div>
    </div> -->
    <div class="footer-body">
      <div class="inner">
        <ul class="item">
          <li class="first">平台</li>
          <li @click="toPage('/platform?type=Enablement')">全球赋能</li>
          <li @click="toPage('/platform?type=Intelligence')">全球情报</li>
          <li @click="toPage('/platform?type=Demand')">全球需求</li>
        </ul>
        <ul class="item">
          <li class="first">资源</li>
          <li @click="toPage('/success-stories')">成功经历</li>
          <li @click="toPage('/knowledge-centre')">知识中心</li>
          <li @click="toPage('/partners')" class="first mt-40">合作伙伴</li>
        </ul>
        <ul class="item">
          <li class="first">产品介绍</li>
          <li @click="toPage('/customs')">关务管理平台</li>
          <li @click="toPage('/tradeCompliance')">全球贸易合规</li>
        </ul>
        <ul class="item">
          <li class="first">公司</li>
          <li @click="toPage('/about')">关于</li>
          <li @click="toPage('/careers')">职业生涯</li>
          <li @click="toPage('/media-center')">媒体中心</li>
        </ul>
        <ul class="item">
          <li class="first">联系我们</li>
          <li @click="toPage('/contact-us')">联系我们</li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      香港美格科技有限公司 Copyright @ 2020 mag-chn.com
      <a href="https://beian.miit.gov.cn/" target="_blank">
        沪ICP备19028688号-1沪公网安备31010402009343号
      </a>
    </div>
    <!-- <div class="footer-bottom">
      香港美格科技有限公司 Copyright © 2025 Xport-e.com
      <a href="https://beian.miit.gov.cn/" target="_blank">
        沪ICP备19028688号-4
      </a>
    </div> -->
  </section>
</template>

<script>
export default {
  name: 'indexFooter',
  data() {
    return {}
  },
  methods: {
    toPage(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="less">
.index-footer {
  background-color: #fff;
  .footer-body {
    padding: 0 5%;
    .inner {
      max-width: 1140px;
      padding: 80px 0;
      margin: 0 auto;
      display: flex;
      gap: 20px;
      .item {
        flex: 1;
        li {
          margin-bottom: 16px;
          cursor: pointer;
          &:hover {
            color: #2f5ad9;
          }
        }
        .first {
          font-weight: 700;
        }
        .last-in {
          padding: 10px 0;
          display: flex;
          align-items: center;
          gap: 20px;
          font-weight: 700;
        }
      }
    }
  }
  .footer-bottom {
    width: 100%;
    height: 45px;
    background-color: #636363;
    text-align: center;
    line-height: 45px;
    font-size: 16px;
    color: #fff;
    a,
    a:hover,
    a:active,
    a:visited {
      color: #fff;
    }
  }
}
</style>
